module.exports = __webpack_public_path__ + "img/Solution_bg.9d3e9d86.png";